export function track(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

export const trackCall = (location) => () => track("phone_call_click", { location });
export const trackText = (location) => () => track("text_click", { location });
export const trackBook = () => track("book_online_click", { source_page: window.location.pathname });
export const trackIntake = () => track("intake_form_download", { source_page: window.location.pathname });
